import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformPredefinedDiscoverCollection } from './predefined-discover-collections.transformers';
import type { PredefinedDiscoverCollectionsCollection } from './predefined-discover-collections.types';

export function predefinedDiscoverCollectionsReducer(
  state: CollectionStateSlice<PredefinedDiscoverCollectionsCollection> = {},
  action: CollectionActions<PredefinedDiscoverCollectionsCollection>,
): CollectionStateSlice<PredefinedDiscoverCollectionsCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'predefinedDiscoverCollections') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<PredefinedDiscoverCollectionsCollection>(
          state,
          transformIntoDocuments(
            [result.collection],
            transformPredefinedDiscoverCollection,
          ),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
